import { semanticColor } from './color.ts';

/**
 * Surface themes. The customer marketplace is premium beauty retail (blush canvas).
 * Retailer and admin portals are operational: neutral canvas, deep plum navigation.
 */
export const surfaceTheme = {
  customer: {
    canvas: semanticColor.surfaceCanvasCustomer,
    card: semanticColor.surfaceCard,
    primaryAction: semanticColor.brandPrimary,
    navigation: 'light',
    density: 'comfortable',
  },
  retailer: {
    canvas: semanticColor.surfaceSubtle,
    card: semanticColor.surfaceCard,
    primaryAction: semanticColor.brandPrimary,
    navigation: 'plum',
    density: 'compact',
  },
  admin: {
    canvas: semanticColor.surfaceSubtle,
    card: semanticColor.surfaceCard,
    primaryAction: semanticColor.brandPrimary,
    navigation: 'plum',
    density: 'compact',
  },
} as const;

export type SurfaceThemeName = keyof typeof surfaceTheme;
